// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2xBNV","additionalInfo":"AgreementModal_additionalInfo__24UEX"};